import React from 'react';
import {FieldArray} from 'formik';
import FormikTextInput from 'src/components/inputs/formik-text-input';
import Label from 'shared/components/label';
import Icon from 'shared/components/icon';
import UnstyledButton from 'src/components/unstyled-button';
import TextButton from 'src/components/TextButton';

const MultimediaLinks = () => (
  <FieldArray
    name="links"
    render={(helpers) => {
      const generalError = helpers.form.errors.links?.length > helpers.form.values.links.length;

      return (
        <>
          {helpers.form.values.links.map((_link, i) => (
            <Label required key={`multimedia-links-${i}`}>
              {i === 0 ? 'Link your Project' : 'Add another link to this project'}
              <div className="multimedia-links">
                <FormikTextInput
                  name={`links.${i}`}
                  placeholder="Paste a link to an image file or video"
                  required={i === 0}
                  className={generalError ? 'error' : ''}
                />
                {i !== 0 && (
                  <UnstyledButton
                    className="multimedia-links-close"
                    onClick={(e) => {
                      e.preventDefault();
                      helpers.remove(i);
                    }}
                  >
                    <Icon iconType="times-r" />
                  </UnstyledButton>
                )}
              </div>
            </Label>
          ))}

          {generalError && (
            <div className="shared-error-text">
              {helpers.form.errors.links[helpers.form.errors.links.length - 1]}
            </div>
          )}

          <TextButton
            type="button"
            color="blue"
            onClick={() => helpers.push('')}
            buttonName="portfolio multimedia multimedia-links add-multimedia-link"
          >
            + Add another link to this Project
          </TextButton>
        </>
      );
    }}
  />
);

export default MultimediaLinks;
